import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  language?: string;
  alternateLanguages?: {
    lang: string;
    href: string;
    hrefLang: string;
  }[];
  structuredData?: Record<string, any>;
}
const SEO: React.FC<SEOProps> = ({
  title = 'Voxie AI - Call & Text AI When Offline',
  description = "Voxie makes generative AI accessible via a voice call or SMS text to a phone number. The best way for people to interact with AI when they're offline.",
  canonicalUrl = 'https://voxie.ai',
  language = 'en',
  alternateLanguages = [],
  structuredData = {}
}) => {
  // Default structured data for organization
  const defaultStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Voxie AI',
    url: 'https://voxie.ai',
    logo: 'https://voxie.ai/logo.png',
    description: description,
    sameAs: ['https://twitter.com/voxieai', 'https://linkedin.com/company/voxieai']
  };
  const mergedStructuredData = {
    ...defaultStructuredData,
    ...structuredData
  };
  return <Helmet data-id="element-323">
      {/* Basic Meta Tags */}
      <html lang={language} data-id="element-324" />
      <title data-id="element-325">{title}</title>
      <meta name="description" content={description} data-id="element-326" />
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} data-id="element-327" />
      {/* Hreflang Tags for Language/Region Variants */}
      {alternateLanguages.map(altLang => <link key={altLang.hrefLang} rel="alternate" href={altLang.href} hrefLang={altLang.hrefLang} data-id="element-328" />)}
      {/* Default hreflang for the current page */}
      <link rel="alternate" href={canonicalUrl} hrefLang={language} data-id="element-329" />
      <link rel="alternate" href={canonicalUrl} hrefLang="x-default" data-id="element-330" />
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} data-id="element-331" />
      <meta property="og:description" content={description} data-id="element-332" />
      <meta property="og:url" content={canonicalUrl} data-id="element-333" />
      <meta property="og:type" content="website" data-id="element-334" />
      <meta property="og:locale" content={language} data-id="element-335" />
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-336" />
      <meta name="twitter:title" content={title} data-id="element-337" />
      <meta name="twitter:description" content={description} data-id="element-338" />
      {/* Explicitly opt out of AMP */}
      <meta name="amp-to-amp-navigation" content="disabled" data-id="element-339" />
      <meta name="googlebot" content="noamp" data-id="element-340" />
      {/* Structured Data */}
      <script type="application/ld+json" data-id="element-341">
        {JSON.stringify(mergedStructuredData)}
      </script>
    </Helmet>;
};
export default SEO;